import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGlobe = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.2504 1.2504)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM1.5332 11.5C1.86803 15.6714 4.9676 19.0597 9 19.832C7.20966 17.4173 6.16711 14.5189 6.01855 11.5H1.5332ZM15.4814 11.5C15.3329 14.5191 14.2896 17.4172 12.499 19.832C16.5319 19.06 19.6319 15.6717 19.9668 11.5H15.4814ZM7.52051 11.5C7.68365 14.4883 8.81864 17.3414 10.75 19.626C12.6814 17.3414 13.8164 14.4883 13.9795 11.5H7.52051ZM9 1.66699C4.96751 2.43929 1.86803 5.82853 1.5332 10H6.01855C6.16712 6.98081 7.20937 4.08188 9 1.66699ZM10.75 1.87305C8.81835 4.15772 7.68366 7.01149 7.52051 10H13.9795C13.8163 7.01149 12.6817 4.15772 10.75 1.87305ZM12.499 1.66699C14.2899 4.08197 15.3329 6.98061 15.4814 10H19.9668C19.6319 5.82821 16.532 2.43894 12.499 1.66699Z",
			fill: "currentColor"
		})
	})
});
export default SvgGlobe;
